import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import AI_CREATE_PROMPT from '../mutations/AI_CREATE_PROMPT';

const useAICreatePrompt = () => {
    const [ createNewPrompt ] = useMutation( AI_CREATE_PROMPT );

    const createPrompt = async ( saveData ) => {
        try {
            console.log( 'Creating prompt with:', saveData );
            
            const response = await createNewPrompt(  { variables: { input: saveData } } );
            const success = response?.data?.createPrompt;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating prompt', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createPrompt         
        };
    }, [] );
};

export default useAICreatePrompt;
